import { Grid } from '@material-ui/core';
import React from 'react';

import { IExtendedPermission } from '~/src/dash/utils/permission_service';
import { H2 } from '~/src/dash/views/component-view';
import { ct } from '~/src/dash/publicaUI';

interface IProps {
  missingPermissions: IExtendedPermission[];
}

interface IPropsErrorPaper {
  err: string;
}

export default class ModelMissingPermission extends React.Component<IProps> {
  render() {
    return (
      <div>
        <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
          <Grid item>
            <H2>{ct('ErrorSorryNoPermissionForSection')}:</H2>
          </Grid>
          <Grid item>{ct('MissingPermission')}:</Grid>
          {this.props.missingPermissions.map((perm: IExtendedPermission) => {
            return <Grid item>{perm.description + '  (' + perm.name + ')'}</Grid>;
          })}
        </Grid>
      </div>
    );
  }
}

export class ModelErrorPaper extends React.Component<IPropsErrorPaper> {
  render() {
    return (
      <div style={{ marginLeft: '36px', marginTop: '20px' }}>
        <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
          <Grid item>
            <H2>{ct('Error')}:</H2>
          </Grid>
          <Grid item>{this.props.err.toString()}</Grid>
        </Grid>
      </div>
    );
  }
}
